import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "Expressions in Freon",
description: "Add grading logic to your DSL by introducing expressions in Freon. Define ScoreExpression variants (question references, number literals, counts), build binary and comparison expressions with priorities, and update the editor to show grading.",
tags: [ "Freon", "expressions", "DSL", "grading", "ScoreExpression", "QuestionReference", "NrOfCorrectAnswers", "NumberLiteralExpression", "binary expressions", "AND", "OR", "comparisons", "Equals", "GreaterThan", "LessThan", "editor projections", "Page", "GradeScore", "tutorial"] ,
modifiedTime: "2025-11-07T17:20:18.626Z",
publishedTime: "2025-11-07T17:20:18.626Z"
    }
  };
};